function ProgressBar({
  percentage,
  containerClass,
}: {
  readonly percentage: number;
  readonly containerClass?: string;
}): JSX.Element {
  return (
    <div className={containerClass}>
      {/* Desktop label (above bar, plain text) */}
      <p
        className="transition-all hidden md:block"
        style={{
          marginLeft: `${percentage === 100 ? percentage - 5 : percentage}%`,
        }}
      >
        {percentage}%
      </p>

      {/* Mobile label (box with arrow) */}
      <div
        className="md:hidden absolute top-full -translate-x-14"
        style={{
          left: `${percentage}%`,
          zIndex: 10000,
        }}
      >
        {/* Box */}
        <div className="relative bg-white shadow -mt-2 p-2 px-3 rounded-md text-xs font-medium text-black z-[9999]">
          <span
            className="absolute -top-2 left-1/2 -translate-x-1/2 w-0 h-0
       border-l-[6px] border-r-[6px] border-b-[8px]
       border-l-transparent border-r-transparent border-b-white z-[99999999]"
          />
          {percentage}%
        </div>
      </div>
      <div className="w-full bg-[#DCDFE4] rounded-full overflow-hidden relative">
        <div
          className="bg-gradient-to-r from-[#18B5B7] to-[#084E8B] rounded-full p-1 transition-all"
          style={{ width: `${percentage}%` }}
        />
      </div>
    </div>
  );
}

export default ProgressBar;
